import { ScrollArea } from "@marine/ui/scroll-area";
import { Separator } from "@marine/ui/separator";
import { SidebarPrimaryMenu } from "./sidebar-primary-menu";
import { SidebarSearch } from "./sidebar-search";
import { SidebarMenuSection } from "./sidebar-menu-section";
import { MenuConfig } from "@/config/types";
import { MENU_SIDEBAR_MAIN, MODULE_CONFIG } from "@/config/layout.config";
import { useLocation } from "react-router-dom";
import { detectModuleFromPath } from "@/lib/breadcrumb";
import type { PortalType, TenantModule } from "@/lib/breadcrumb";

export type { PortalType, TenantModule };

interface SidebarSecondaryProps {
  menuConfig?: MenuConfig;
  portalType?: PortalType;
}

export function SidebarSecondary({ 
  menuConfig, 
  portalType = 'platform',
}: SidebarSecondaryProps) {
  const { pathname } = useLocation();
  const activeModule = detectModuleFromPath(pathname);

  // Platform portal - just show the platform menu
  if (portalType === 'platform') {
    return (
      <ScrollArea className="grow shrink-0 h-[calc(100vh-1rem)] lg:h-[calc(100vh-4rem)] mt-0 mb-2.5">
        <SidebarSearch />
        <SidebarPrimaryMenu menuConfig={menuConfig || MENU_SIDEBAR_MAIN} />
      </ScrollArea>
    );
  }

  // Tenant portal - get module config and render dynamically
  const moduleConfig = MODULE_CONFIG[activeModule];
  
  return (
    <ScrollArea className="grow shrink-0 h-[calc(100vh-1rem)] lg:h-[calc(100vh-4rem)] mt-0 mb-2.5">
      <SidebarSearch />
      
      {/* Module Dashboard */}
      <SidebarPrimaryMenu menuConfig={moduleConfig.dashboard} />
      
      {/* Module Sections (dynamically rendered) */}
      {moduleConfig.sections.map((section) => (
        <div key={section.id}>
          <Separator className="my-2.5" />
          <SidebarMenuSection config={section.menu} sectionId={section.id} />
        </div>
      ))}
      
      {/* Placeholder message for modules under development */}
      {moduleConfig.placeholder && (
        <div className="px-4 py-8 text-center text-muted-foreground">
          <p className="text-sm">{moduleConfig.placeholder}</p>
        </div>
      )}
    </ScrollArea>
  );
}
